import React, { useState } from "react";
import ChangeFactorTable from "../../Components/ChangeFactorTable/ChangeFactorTable";
import MenuTitle from "../../Components/MenuTitlle/MenuTitle";
import Style from "./ChangeFactor.module.css";
import "../ManageCustomer/ManageCustomer.css";
// import Modal from "../../Components/Modal/Modal";
import ChangeDetailProduct from "../../Components/ChangeDetailProduct/ChangeDetailProduct";
import { Modal } from "react-bootstrap";
import {
  changeFactorListPostApi,
  getProductDetailApi,
} from "../../Api/BarestSupplierServices";
import ChangeProduct from "../../Components/ChangeProduct/ChangeProduct";
import { useEffect } from "react";
import { orderListDetailApi } from "../../Api/SupplierServices";
import { separate } from "../../Functions/NumberSeprator";
import { errorToast, succToast} from "../../Utils/Toast/Toast";
import FinalProductList from "../../Components/FinalProductList/FinalProductList";
import Factor from "../../Components/Factor/Factor";

const ChangeFactor = (props) => {
  const [purchased, setPurchased] = useState(false);
  const [openChangeProduct, setOpenChangeProduct] = useState(false);
  const [rawInfo, setRawInfo] = useState();
  const [finalFactorModal, setFinalFactorModal] = useState(false);

  const [disable, setDisable] = useState(false);
  const [orderListDetails, setOrderListDetails] = useState();
  const [searchValue, setSearchValue] = useState();
  const [allProducts, setAllProducts] = useState([]);
  useEffect(() => {
    getOrderListsDetail();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const btnHandler = (id, data) => {
    setRawInfo(data);
    //// change detail ////////
    if (id === 1) {
      setPurchased(true);
    }

    /////change product ///////
    else if (id === 2) {
      const info = {
        exist: 1,
        category_id: 0,
      };
      getProductDetailApi(info, (res) => {
        setSearchValue(res.products);
      });
      setOpenChangeProduct(true);
    }
  };

  const handleClose = () => {
    setPurchased(false);
    setOpenChangeProduct(false);
    setFinalFactorModal(false);
  };

  const changeFactorList = () => {
    setDisable(true);
    const info = {
      id: props.location.state,
      products: allProducts,
    };
    changeFactorListPostApi(info, (res) => {
      if (res.status === 1) {
        setDisable(false);
        setFinalFactorModal(true);
        succToast("با موفقیت ویرایش شد")
      } else {
        setDisable(false);
        errorToast(res.message);
      }
    });
    getOrderListsDetail();
  };

  const changeProductList = (value) => {
    console.log(allProducts);
    let arraytest = allProducts;
    arraytest.push(value);
  };
  const changeFactor = (value) => {
    console.log(allProducts);
    let arraytest = allProducts;
    arraytest.push(value);
    const items = arraytest.findIndex(
      (item) => item.product_id === value.product_id
    );
    arraytest.splice(items, 1);
    if (items === arraytest.length) {
      arraytest.push(value);
    }
    setAllProducts(arraytest);
  };
  const getOrderListsDetail = async () => {
    const data = await orderListDetailApi(props.location.state);
    setOrderListDetails(data.products);
  };
  const data =
    orderListDetails &&
    orderListDetails.map((item, index) => {
      return {
        key: index,
        id: item.id,
        name: item.name,
        count: item.count,
        newCount: item.new_count,
        price: separate(item.price),
        newPrice: separate(item.new_price),
        pProductId: item.p_product_id,
        available:item.availability
      };
    });
  return (
    <div className={Style.pageholder}>
      <MenuTitle title={"ویرایش فاکتور"} />
      <Modal
        style={{ marginTop: "14rem" }}
        show={purchased}
        onHide={handleClose}
      >
        <Modal.Body>
          <ChangeDetailProduct
            rawInfo={rawInfo}
            handleClose={handleClose}
            sendData={changeFactor}
          />
        </Modal.Body>
      </Modal>

      <Modal
        style={{ marginTop: "14rem" }}
        show={openChangeProduct}
        onHide={handleClose}
      >
        <Modal.Body>
          <ChangeProduct
            handleClose={handleClose}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            rawInfo={rawInfo}
            setChangeProduct={changeProductList}
          />
        </Modal.Body>
      </Modal>

      <Modal
        style={{ marginTop: "14rem" }}
        show={finalFactorModal}
        onHide={handleClose}
      >
        <Modal.Body>
          <FinalProductList data={orderListDetails}/>
        </Modal.Body>
      </Modal>

      <ChangeFactorTable
        btnHandler={btnHandler}
        orderId={props.location.state}
        data={data}
      />
      <div className={Style.updateBtnHolder}>
        <button
          disabled={disable}
          className={Style.updateBtn}
          onClick={changeFactorList}
        >
          ویرایش
        </button>
      </div>
    </div>
  );
};

export default ChangeFactor;
